module.exports = __webpack_public_path__ + "lightbox/lightbox.min.css";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=lightbox/[name].[ext]!./~/lightbox2/dist/css/lightbox.min.css
// module id = 154
// module chunks = 0